<template>
  <div class="subscription-text">
    <div v-if="hasMarketingPrice">
      <span v-html="getPriceSubscriptionText"></span
      ><span class="rule" @click="openJoinRules">{{ $t('FoodC_subscription_VPMP_seXT') }}</span>
    </div>
    <div v-else>
      <span v-html="getNoPriceSubscriptionText"></span
      ><span class="rule" @click="openJoinRules">{{ $t('FoodC_subscription_VPMP_seXT') }}</span>
    </div>
  </div>
</template>

<script>
import { DIDI_FOOD_BRAND } from '../common/enumsUtil.js'
import { openJoinRules } from '@/page/member/common/utils.js'

export default {
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      DIDI_FOOD_BRAND,
      isShowTakeRule: false,
    }
  },
  computed: {
    brandName() {
      return this.membership?.brandName
    },
    hasMarketingPrice() {
      // 无营销价格  售价=订阅价
      // 有营销价格  售价 < 订阅价
      // 订阅价：renewPrice
      // 售价：price
      const renewPrice = this.membership?.renewPrice || 0
      const price = this.membership?.price || 0
      return price < renewPrice
    },
    getMoney1() {
      return this.membership?.priceSplit?.display || ''
    },
    getMoney2() {
      return this.membership?.renewPriceSplit?.display || ''
    },
    getPriceSubscriptionText() {
      return this.$t('FoodC_didipack_XQlZ_sNjR', {
        money1: this.getMoney1,
        money2: this.getMoney2,
        didipackbrand: this.brandName,
        didifoodbrand: DIDI_FOOD_BRAND,
      })
    },
    getNoPriceSubscriptionText() {
      return this.$t('FoodC_didipack_kIYJ_MqHw', {
        money2: this.getMoney2,
        didifoodbrand: DIDI_FOOD_BRAND,
      })
    },
  },
  methods: {
    openJoinRules,
  },
}
</script>

<style lang="scss" scoped>
.subscription-text {
  padding: 48px 32px;
  font-family: DiDiSans-Pro-Regular;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 32px;
  ::v-deep .overbold {
    opacity: 0.6;
    font-family: DiDiSans-Pro-Bold;
    font-size: 28px;
    color: #000000;
  }
}

.rule {
  font-family: DiDiSans-Pro-Medium;
  font-size: 24px;
  color: #000000;
  line-height: 24px;
  text-decoration: underline;
}
</style>
